import axios from 'axios'
import * as commondef from './common'
import $store from '../store/index'
import $router from '../router'
let accessToken = null

function h5UseCookieFlag () {
  let flag = 0
  try {
    if ($store.state && $store.state.h5Config) {
      if ($store.state.h5Config.h5Config && $store.state.h5Config.h5Config.useCookie) {
        flag = $store.state.h5Config.h5Config.useCookie
      }
    }
    if (localStorage.getItem('vuex')) {
      const vuexObj = JSON.parse(localStorage.getItem('vuex'))
      if (vuexObj.h5Config && vuexObj.h5Config.h5Config && vuexObj.h5Config.h5Config.funCfg && vuexObj.h5Config.h5Config.funCfg.useCookie) {
        flag = vuexObj.h5Config.h5Config.funCfg.useCookie
      }
    }
  } catch (e) {
    console.log('获取h5Config出现了错误', e)
  }
  return flag
}

// 根据条件是否进行cookie存储
export const setCookieByConfig = (textCfg, funCfg) => {
  // console.log('setCookieByConfig', textCfg, funCfg)
  // console.log('在api打印配置', $store.state.h5Config.h5Config)
  // console.log('在api打印配置h5flag', storeUseCookie)

}
// cookie
export const setCookie = function (key, value, expiredays) {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = key + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
}

export const setUser = function (userInfo) {
  localStorage.setItem(commondef.keyUserInfo, userInfo)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyUserInfo, userInfo, 15)
  }
}
export const setConfig = function (configInfo) {
  localStorage.setItem(commondef.keyConfigInfo, configInfo)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyConfigInfo, configInfo, 15)
  }
}
export const getConfigByCookie = function () {
  let result = localStorage.getItem(commondef.keyConfigInfo)
  if (!result) {
    result = getCookie(commondef.keyConfigInfo)
    localStorage.setItem(commondef.keyConfigInfo, result)
  }
  return JSON.parse(result)
}
export const getConfig = function () {
  let result = $store.state.configInfo ? $store.state.configInfo.configInfo : null
  if (!result) {
    const resultLocal = localStorage.getItem(commondef.keyConfigInfo)
    result = JSON.parse(resultLocal)
  }
  return result
}
export const setShowWizard = function (showWizard) {
  localStorage.setItem(commondef.keyShowWizard, showWizard)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyShowWizard, showWizard, 15)
  }
}
export const setMsgBadge = function (msgBadge) {
  localStorage.setItem(commondef.keyMsgBadge, msgBadge)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyMsgBadge, msgBadge, 15)
  }
}
export const setFace = function (face) {
  localStorage.setItem(commondef.keyFace, face)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyFace, face, 15)
  }
}
export const setPasswordCheck = function (passwordCheck) {
  localStorage.setItem(commondef.keyPasswordCheck, passwordCheck)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyPasswordCheck, passwordCheck, 15)
  }
}
export const setH5Config = function (h5Config) {
  localStorage.setItem(commondef.keyH5Config, JSON.stringify(h5Config))
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyH5Config, h5Config, 15)
  }
}

export const getCookie = function (name) {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      let end = document.cookie.indexOf(';', start)
      if (end === -1) end = document.cookie.length
      return unescape(document.cookie.substring(start, end))
    }
  }
  return ''
}

export const setAccessToken = function (token) {
  localStorage.setItem(commondef.keyAccessToken, token)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyAccessToken, token, 15)
  }
}

export const removeAccessToken = function () {
  localStorage.removeItem(commondef.keyAccessToken)
  localStorage.removeItem(commondef.keyUserInfo)
  localStorage.removeItem(commondef.keyMsgBadge)
  localStorage.removeItem(commondef.keyPasswordCheck)
  localStorage.removeItem(commondef.keyFace)
  localStorage.removeItem(commondef.keyH5Config)
  if (h5UseCookieFlag()) {
    setCookie(commondef.keyAccessToken, '', -1)
    setCookie(commondef.keyUserInfo, '', -1)
    setCookie(commondef.keyMsgBadge, '', -1)
    setCookie(commondef.keyPasswordCheck, '', -1)
    setCookie(commondef.keyFace, '', -1)
    setCookie(commondef.keyH5Config, '', -1)
  }
}

export const getPublicPara = function (notneed) {
  const params = {
    app_key: '3F6AE6D9E-244D-46B1-A8CC-3D5A90C3823A',
    app_pass: 'D410FAC1-7b0A-4522-AFEA-B3650AF14CA1'
  }
  if (!notneed) {
    if (h5UseCookieFlag()) {
      params.access_token = getLocalStorageByCookie(commondef.keyAccessToken, accessToken)
    }
    params.access_token = getLocalStorage(commondef.keyAccessToken, accessToken)
  }
  return params
}

export const getLocalStorageByCookie = function (name) {
  let val = localStorage.getItem(name)
  if (!val) {
    val = getCookie(name)
    localStorage.setItem(name, val)
  }
  return val
}
export const getLocalStorage = function (name) {
  const val = localStorage.getItem(name)
  return val
}

export const axioInstance = axios.create({
  baseURL: commondef.baseUrlApi,
  headers: { 'Content-Type': 'application/json' },
  timeout: 50000
})

axioInstance.interceptors.response.use(handleRes, function (error) {
  return Promise.reject(error)
})

axioInstance.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export const axioInstance2 = axios.create({
  baseURL: commondef.baseUrl,
  headers: { 'Content-Type': 'application/json' },
  timeout: 50000
})

axioInstance2.interceptors.response.use(handleRes, function (error) {
  return Promise.reject(error)
})

axioInstance2.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

function handleRes (response) {
  if (response.status >= 200 && response.status < 300) {
    const res = response.data
    if (res && res.code === commondef.resCode.Unauthorized) {
      $router.replace('/login')
        .catch(e => console.log('未登录', e))
      return
    } else if (response.config.url.indexOf('/login') > 0) {
      accessToken = response.data.access_token
      // if (accessToken && process.browser) {
      localStorage.setItem(commondef.keyAccessToken, accessToken)
      // }
    }
    return res
  } else {
    return { status: response.status, code: Number.MAX_VALUE, msg: '' }
  }
}

export const axioForm = axios.create({
  headers: { 'Content-Type': 'multipart/form-data' },
  baseURL: commondef.baseUrlApi
})

axioForm.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axioForm.interceptors.response.use(handleRes, function (error) {
  return Promise.reject(error)
})

export const axioForm2 = axios.create({
  headers: { 'Content-Type': 'multipart/form-data' },
  baseURL: commondef.baseUrl
})

axioForm2.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axioForm2.interceptors.response.use(handleRes, function (error) {
  return Promise.reject(error)
})

export const getPicUrl = (path) => {
  return commondef.baseUrl + '/get_img/' + path
}

export const axiosRequest = (url, para) => {
  // url  请求api
  // formData  form-date 请求
  // isNotToken  为true不要token
  const isNotToken = para && para.isNotToken
  const params = getPublicPara(isNotToken)
  if (para) {
    for (const item in para) {
      // eslint-disable-next-line no-prototype-builtins
      if (!para.hasOwnProperty(item)) {
        continue
      }
      if (item === 'formData' || item === 'isNotToken') {
        continue
      }
      if (para[item] || para[item] === 0 || para[item] === false) {
        params[item] = para[item]
      }
    }
  }
  if (para && para.formData) {
    const obj = new FormData()

    // 传参设置接口需要的json和file
    obj.append('json', JSON.stringify(params.json))
    if (params.files) {
      params.files.forEach(item => {
        obj.append('files', item)
      })
    } else if (params.file) {
      obj.append('file', params.file)
    }

    if (url.startWith('peripheral.') || url.startWith('video.')) {
      return axioForm2.post(url, obj)
    } else {
      return axioForm.post(url, obj)
    }
  } else {
    if (url.startWith('peripheral.') || url.startWith('video.')) {
      return axioInstance2.post(url, params)
    } else {
      return axioInstance.post(url, params)
    }
  }
}
// get请求
export const axiosRequestGet = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(url, { params }).then(res => {
      resolve(res.data)
    }).catch((err) => {
      reject(err.data)
    })
  })
}

export const urlList = {
  get_habit: 'system.self.habit.query',
  set_habit: 'system.self.habit.set_habit',
  get_air_status: 'peripheral/peripheral_device.query',
  set_air_status: 'peripheral/aircondition.multiple_set',
  fault_answer: 'system.announcement.fault.answer',
  login: 'login',
  remote_login: 'system.remote.login',
  logout: 'system.self.logout',
  oauthLogout: 'system.unified_login.oauth.oauth_logout',
  vip_login: 'vip_login',
  unifiedLogin: 'system.unified_login.ap_login',
  // 获取授权码的URL
  getAuthCodeUrl: 'system.unified_login.oauth.get_auth_code_url',
  // 授权码登录
  oauthLogin: 'system.unified_login.oauth.oauth_login',
  historyOrder: 'piano.get_my_book',
  getPianoUserRecord: 'system.room.get_self_use_list',
  getPersonalInfo: 'system.self.get_xcx_info',
  // getPianoCourse: 'piano.get_teacher_class',
  getPianoCourse: 'system.course.simple.course.get_my_course',
  modifyPassword: 'system.self.modify_pass',
  bindWechat: 'xcx.up_bind',
  unBindWechat: 'xcx.unbind',
  getMessageList: 'system.announcement.get_self_xcx_msg_list',
  querySystemMsg: 'system.announcement.common.query',
  queryFaultMsg: 'system.announcement.fault.query',
  queryComplainttMsg: 'system.announcement.complaint.query',
  queryForceDownMsg: 'system.announcement.force_down.query',
  readMsg: 'system.announcement.set_read',
  // 获取个人所以未读消息数
  getSelfAllNoReadTotal: 'system.announcement.get_self_all_no_read_total',
  // 违规违纪通知查询
  violatPunisheQuery: 'system.announcement.violate.query',
  // 消极处罚通知查询
  negativePunishQuery: 'system.announcement.negative.query',
  // 空占处罚通知查询
  emptyPunishQuery: 'system.announcement.empty.query',
  // 不关门签退处罚通知查询
  unLockDoorPunishQuery: 'system.announcement.unlockdoor.query',
  // 加课取消预约
  cancelBookByCourse: 'system.announcement.add_course_cancel_book.query',
  // 管理员取消预约
  cancelBookAdmin: 'system.announcement.cancel_book_admin.query',
  // 消极处罚通知签到详情
  negativePunishDetails: 'award_punish.detail.negative',
  // 空占处罚通知签到详情
  emptyPunishDetails: 'award_punish.detail.empty',
  // 不关门签退处罚通知签到详情
  unLockDoorPunishDetails: 'award_punish.detail.unlockdoor',
  // 积极练习通知签到详情
  positiveAwardDetails: 'award_punish.detail.positive',
  // 管理理员奖表扬查询
  adminAwardQuery: 'system.announcement.award.query',
  // 管理理员奖表扬详情
  adminAwardDetail: 'award_punish.detail.award',
  // 获取通知
  getNotice: 'system.setting.notice.get',
  // 上签退设置
  getUpDownSetting: 'system.setting.up_down.get',
  // 查询门禁机设备状态
  queryRoomEntranceDevice: 'system.room.query_room_entrance_device',
  // 获取琴房开锁二维码和密码
  getPianoQrCodePassword: 'piano.get_qr_img',
  // 获取课程琴房开锁二维码
  getCoursePianoQrCode: 'piano.get_course_qr_img',
  // 获取琴房故障类别
  getFaultTypeList: 'system.type.fault.get_list',
  // 多张图片上传  data 下价格path路径数组
  uploadFile: 'upload',
  // // 故障上报新
  addFaultMsg: 'system.announcement.fault.add',
  // 取消预约
  cancelReservedPiano: 'piano.cancel_one_book',
  // 意见反馈
  addFeedBack: 'system.announcement.complaint.add',
  // 获取楼层数据
  getBuildingInfo: 'system.room.rate_of_util',
  // 通过楼层查找预约情况
  getFloorDetail: 'piano.get_available_room',
  // 获取琴房可预约时间
  getRoomCanTime: 'piano.get_can_hour',
  // 获取全局配置
  getConfig: '/system.setting.appointment.get',
  // 获取某天某个琴房所有预定
  getPianoOneDayReserved: 'piano.get_all_book',
  // 预约琴房
  appointmentPiano: 'piano.book_one_room',
  // 学号开锁
  studentNumberOpenLock: 'system.room.stu_remote_open',
  // 返回签入
  backSignIn: 'piano.back.back_use_book',
  // 返回签出
  backSignOut: 'piano.back.back_use_out',
  // 返回签二维码
  backQR: 'piano.back.get_back_use_qr',
  // 获取门磁状态
  getDoorStatus: 'piano.get_room_status',
  // 签退
  downPiano: 'piano.down',
  // 查询白名单列表
  getWhiteNameList: 'system.room.electron_open.get_white_right',
  // 续约
  continuePiano: 'piano.continue',
  // 获取签到URL
  getSignInUrl: 'entrance_guard_device.get_check_in_h5',
  // 获取签退URL
  getSignOutUrl: 'entrance_guard_device.get_check_out_h5',
  // 扫二维码签到
  signIn: 'entrance_guard_device.qr_up',
  // 扫二维码签退
  signOut: 'entrance_guard_device.qr_down',
  // h5员工新增绑定人脸信息
  bindFace: 'piano.enroll.enroll',
  // h5琴房绑定人脸信息
  pianoBindFace: 'piano.face.bind',
  // h5琴房查询人脸信息
  queryFace: 'piano.face.bind_type_list',
  // h5查询 班组/班级
  queryTeamGroupOrClass: 'system.organization.class.get_list',
  // h5查询 班组类型/年级
  queryTeamGroupTypeOrGrade: 'system.type.grade.get_list',
  // h5查询 组织
  queryOrganization: 'system.organization.get_tree',
  // 获取登录随机SVG图片
  getLoginRandom: 'login_random',
  // 获取配置
  getH5Config: 'system.h5_setting.get_config'

}

export const filterMenu = function (rt, menu) {
  for (let i = 0; i < menu.length; i++) {
    filterPath(rt[0], menu[i].tag)
  }
  function filterPath (obj, path) {
    if (Array.isArray(obj.children) && obj.children.length) {
      for (let i = 0; i < obj.children.length; i++) {
        if (obj.children[i].path === path) {
          obj.children[i].allow = true
          return
        } else if (
          Array.isArray(obj.children[i].children) &&
                    obj.children[i].children.length
        ) {
          filterPath(obj.children[i], path)
        }
      }
    }
  }
  function delNotAllow (obj) {
    if (Array.isArray(obj.children) && obj.children.length) {
      for (let i = 0; i < obj.children.length; i++) {
        if (!obj.children[i].allow) {
          obj.children.splice(i, 1)
          return true
        } else if (
          Array.isArray(obj.children[i].children) &&
                    obj.children[i].children.length
        ) {
          const result = delNotAllow(obj.children[i])
          if (result) return true
        }
      }
    }
    return false
  }
  while (delNotAllow(rt[0])) { }

  return rt
}
